import React, { useEffect, useRef, useState } from 'react';
import PageTemplate from '../Templates/PageTemplate';
import { useNavigate, useParams } from 'react-router';
import * as Icons from "../HouseStyle/Icons";
import middleware from '../Api/Middleware';
import ToastWarning from '../Toasts/ToastWarning';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import ToastError from '../Toasts/ToastError';
import MailIcon from './Icons/mail.png';
import PhoneIcon from './Icons/telephone.png';
import TruckIcon from './Icons/delivery-truck.png';
import PaperIcon from './Icons/paper-white.png';
import placeholder from './Icons/empty-placeholder.jpg';
import deliveryTruckBlue from './Icons/delivery-truck-blue.png';
import Backbutton from "../Products/subpages/images/BackIcon.svg";
import ToastInfo from '../Toasts/ToastInfo';
import CurrencyInput from 'react-currency-input-field';
import { BorderedDropDown } from '../HouseStyle/Components/DropDowns';
import { BorderedSquareMoneyInput, BorderedTextInput } from '../HouseStyle/Components/Inputs';
import { BackButton } from '../HouseStyle/Components/Buttons';
import { RegularCheckBox } from '../HouseStyle/Components/Checkboxes';
import { formatCurrency, parseCurrency } from '../../utils';

const CancelOrder = () => {
    const { order_number } = useParams();

    const navigate = useNavigate();
    const [pageIsLoading, setPageIsLoading] = useState(true);

    const [soldProducts, setSoldProducts] = useState([]);
    const [order, setOrder] = useState([]);

    const fetchAll = async () => {
        const ordersResponse = await middleware.get(`orders/fullorder?order_number=${order_number}`);
        const order = ordersResponse.data.data;
        if (!order) {
            ToastError(`Deze bestelling bestaat niet.`);
            navigate(`/bestellingen`);
            return;
        }

        setOrder(order);
        setSoldProducts(order.orders_sold_products);
        if (!order.orders_sold_products.find((e) => e.amount > e.items_credited)) {
            ToastInfo("Alle producten zijn al gecrediteerd")
            navigate("/bestellingen/overzicht/" + order_number)
        }
        setPageIsLoading(false);
    }
    const [cancelProcessedProducts, setCancelProcessedProducts] = useState([]);
    const [cancelUnProcessedProducts, setCancelUnProcessedProducts] = useState([]);
    const [cancelExtraProducts, setCancelExtraProducts] = useState([]);
    const [productRestitution, setProductRestitution] = useState(0);
    const [restitutionCost, setRestitutionCost] = useState('');
    const [extracost, setExtraCost] = useState(0);
    const [extra, setExtra] = useState('');
    const [cancelReason, setCancelReason] = useState(null);
    const [otherCancelReason, setOtherCancelReason] = useState(null);
    const [selectAll, setSelectAll] = useState(false);
    const deliveryRestituted = order?.creditations?.find(cred => cred.delivery_restituted === 1) ? true : false;    

    useEffect(() => {
        if (extra === 1) {
            if (order?.delivery_cost != null) {
                setExtraCost(order.delivery_cost);
            }
        } else {
            setExtraCost('');
        }
    }, [order, extra]);

    const changeUnProcessedProductCancelValue = (event, productToProcces, field) => {
        let value = event?.target?.value ?? event;
        
        if (field == "addToStock") {
            value = event.target.checked;
            // Handle checkbox separately
            let updated = { ...cancelUnProcessedProducts[productToProcces.sold_product_id] };
            updated[field] = value;
            setCancelUnProcessedProducts({ ...cancelUnProcessedProducts, [productToProcces.sold_product_id]: updated });
            return; // Exit early for addToStock
        }

        let discount = 0;
        if (productToProcces.sale_unit === 0) {
            discount = Number(productToProcces.sale_amount);
        } else {
            const discountPercentage = Number(productToProcces.sale_amount);
            discount = productToProcces.price_incl_tax * (discountPercentage / 100);
        }

        const price = (parseCurrency(productToProcces.price_incl_tax) - discount);

        if (field === 'restitution') {
            const rawValue = value;
            const numericValue = parseFloat(String(rawValue).replace(',', '.')) || 0;
            const max = Number(price * (cancelUnProcessedProducts[productToProcces.sold_product_id]?.value ?? 1)).toFixed(2);
            
            if (numericValue > parseFloat(max)) {
                let updated = { ...cancelUnProcessedProducts[productToProcces.sold_product_id] };
                updated[field] = max;
                setCancelUnProcessedProducts({ ...cancelUnProcessedProducts, [productToProcces.sold_product_id]: updated });
            } else {
                let updated = { ...cancelUnProcessedProducts[productToProcces.sold_product_id] };
                updated[field] = rawValue;
                setCancelUnProcessedProducts({ ...cancelUnProcessedProducts, [productToProcces.sold_product_id]: updated });
            }
            return;
        }

        let max;
        if (field == 'value') {
            max = productToProcces.amount - productToProcces.items_processed - productToProcces.items_credited;
            
            if (Number(parseFloat(value)) > max) {
                let updated = { ...cancelUnProcessedProducts[productToProcces.sold_product_id] };
                updated[field] = max;
                updated['restitution'] = (parseCurrency(max * price)).toFixed(2).replace('.', ',');
                updated['addToStock'] = true; // Auto-check when value is set
                setCancelUnProcessedProducts({ ...cancelUnProcessedProducts, [productToProcces.sold_product_id]: updated });
            } else {
                let updated = { ...cancelUnProcessedProducts[productToProcces.sold_product_id] };
                updated[field] = value;
                if (value === undefined || value === 0 || value === '') {
                    updated['restitution'] = '';
                    updated['addToStock'] = false; // Uncheck when cleared
                } else {
                    updated['restitution'] = (parseCurrency(value * price)).toFixed(2).replace('.', ',');
                    updated['addToStock'] = true; // Auto-check when value is set
                }
                setCancelUnProcessedProducts({ ...cancelUnProcessedProducts, [productToProcces.sold_product_id]: updated });
            }
        }
    }

    const changeProcessedProductCancelValue = (event, productToProcces, field) => {
        let value = event?.target?.value ?? event;
        
        if (field == "addToStock") {
            value = event.target.checked;
            // Handle checkbox separately
            let updated = { ...cancelProcessedProducts[productToProcces.sold_product_id] };
            updated[field] = value;
            setCancelProcessedProducts({ ...cancelProcessedProducts, [productToProcces.sold_product_id]: updated });
            return; // Exit early for addToStock
        }

        let discount = 0;
        if (productToProcces.sale_unit === 0) {
            discount = Number(productToProcces.sale_amount);
        } else {
            const discountPercentage = Number(productToProcces.sale_amount);
            discount = productToProcces.price_incl_tax * (discountPercentage / 100);
        }

        const price = (parseCurrency(productToProcces.price_incl_tax) - discount);

        if (field === 'restitution') {
            const rawValue = value;
            const numericValue = parseFloat(String(rawValue).replace(',', '.')) || 0;
            const max = Number(price * (cancelProcessedProducts[productToProcces.sold_product_id]?.value ?? 1)).toFixed(2);
            
            if (numericValue > parseFloat(max)) {
                let updated = { ...cancelProcessedProducts[productToProcces.sold_product_id] };
                updated[field] = max;
                setCancelProcessedProducts({ ...cancelProcessedProducts, [productToProcces.sold_product_id]: updated });
            } else {
                let updated = { ...cancelProcessedProducts[productToProcces.sold_product_id] };
                updated[field] = rawValue;
                setCancelProcessedProducts({ ...cancelProcessedProducts, [productToProcces.sold_product_id]: updated });
            }
            return;
        } else if (value === '') {
            value = 0;
        }

        let max;
        if (field == 'value') {
            max = productToProcces.items_processed;
            
            if (parseFloat(value) > max) {
                let updated = { ...cancelProcessedProducts[productToProcces.sold_product_id] };
                updated['restitution'] = Number(max * price).toFixed(2).replace('.', ',');
                updated[field] = max;
                updated['addToStock'] = true; // Auto-check when value is set
                setCancelProcessedProducts({ ...cancelProcessedProducts, [productToProcces.sold_product_id]: updated });
            } else {
                let updated = { ...cancelProcessedProducts[productToProcces.sold_product_id] };
                if (value === undefined || value === 0 || value === '') {
                    updated['restitution'] = '';
                    updated['addToStock'] = false; // Uncheck when cleared
                } else {
                    updated['restitution'] = (parseFloat(value) * price).toFixed(2).replace('.', ',');
                    updated['addToStock'] = true; // Auto-check when value is set
                }
                updated[field] = value;
                setCancelProcessedProducts({ ...cancelProcessedProducts, [productToProcces.sold_product_id]: updated });
            }
        }
    }

    const handleSelectAllChange = (event) => {
        const checked = event.target.checked;
        setSelectAll(checked);

        // Werk alle producten bij om 'addToStock' bij te werken naar 'checked' status
        setCancelProcessedProducts(prev => {
            const updatedProducts = { ...prev };
            Object.keys(updatedProducts).forEach(productId => {
                if (updatedProducts[productId].value > 0) {
                    updatedProducts[productId].addToStock = checked;
                }
            });
            return updatedProducts;
        });

        setCancelUnProcessedProducts(prev => {
            const updatedProducts = { ...prev };
            Object.keys(updatedProducts).forEach(productId => {
                if (updatedProducts[productId].value > 0) {
                    updatedProducts[productId].addToStock = checked;
                }
            });
            return updatedProducts;
        });

        setCancelExtraProducts(prev => {
            const updatedProducts = { ...prev };
            Object.keys(updatedProducts).forEach(productId => {
                updatedProducts[productId].addToStock = checked;
            });
            return updatedProducts;
        });
    };
    
    useEffect(() => {
        fetchAll();
    }, []);

    const calculateProductRestitution = () => {
        let total = 0;
        
        const parseValue = (val) => {
            if (val === '' || val === undefined || val === null) return 0;
            if (typeof val === 'string') {
                // Replace comma with dot and parse
                return parseFloat(val.replace(',', '.')) || 0;
            }
            return Number(val) || 0;
        };
        
        Object.entries(cancelUnProcessedProducts).forEach((e) => {
            total += parseValue(e[1].restitution);
        });
        Object.entries(cancelProcessedProducts).forEach((e) => {
            total += parseValue(e[1].restitution);
        });
        Object.entries(cancelExtraProducts).forEach((e) => {
            total += parseValue(e[1].restitution);
        });

        if (isNaN(total)) {
            total = 0;
        }

        setProductRestitution(total + Number(extracost || 0));
        return total;
    }

    const cancelOrder = async () => {
        try {
            let creditation_products = [];
            creditation_products.push(
                ...Object.entries(cancelUnProcessedProducts)
                    .filter(([key, val]) => val.value > 0)
                    .map(([key, val]) => ({
                        amount: val.value,
                        sold_product_id: parseInt(key),
                        restitution: val.restitution,
                        addToStock: val.addToStock ? 1 : 0
                    }))
            );

            creditation_products.push(
                ...Object.entries(cancelProcessedProducts)
                    .filter(([key, val]) => val.value > 0)
                    .map(([key, val]) => ({
                        amount: val.value,
                        sold_product_id: parseInt(key),
                        restitution: val.restitution,
                        addToStock: val.addToStock ? 1 : 0,
                        type: 'processed'
                    }))
            );

            creditation_products.push(
                ...Object.entries(cancelExtraProducts)
                    .filter(([key, val]) => val.value > 0)
                    .map(([key, val]) => ({
                        amount: val.value,
                        restitution: val.restitution,
                        addToStock: val.addToStock ? 1 : 0
                    }))
            );

            if (!creditation_products.length > 0) {
                ToastError('Er zijn geen producten geselecteerd', 'no_products_selected', 2000);
                return;
            }

            if (!cancelReason || (cancelReason === 'other' && !otherCancelReason)) {
                ToastError('Er is geen annuleringsreden geselecteerd', 'invalid_creditation_reason', 2000);
                return;
            }

            setPageIsLoading(true);

            const res = await middleware.post("/orders/addcreditation", {
                order_id: order.order_id,
                restitution_total: calculateProductRestitution() + parseCurrency(extracost),
                restitution_cost: parseCurrency(restitutionCost),
                delivery_restituted: extra === 1 ? true : false,
                creditation_reason: cancelReason === 'other' ? otherCancelReason : cancelReason,
                creditation_products: creditation_products,
                payment_method: order.payments.map(e => e.payment_method.method_name).toString(),
            });

            navigate("/bestellingen/overzicht/" + order_number);
        } catch (error) {
            ToastError(`Er is iets fout gegaan tijdens het crediteren van de order. Probeer het later opnieuw`);
        }
        setPageIsLoading(false);
    }

    useEffect(() => {
        if (cancelExtraProducts, cancelProcessedProducts, cancelUnProcessedProducts) {
            calculateProductRestitution();
        }
    }, [cancelExtraProducts, cancelProcessedProducts, cancelUnProcessedProducts, extracost, restitutionCost])

    return (
        <PageTemplate pageIsLoading={pageIsLoading} navbarTitle={"Order HUB"}>
            <div className='w-100'>
                <div className="d-flex mb-4 justify-content-between">
                    <BackButton text={`Annuleren bestelling # ${order_number}`} disabled={false} onClickFunction={() => navigate(`/bestellingen/overzicht/${order_number}`)} />
                </div>
                <div className='row pe-3'>
                    <div className='d-flex flex-column col-xxl-8 col-12'>
                        {soldProducts.find((e) => e.items_processed + e.items_credited < e.amount) && (
                            <div className='whiteBox mb-4 me-2 p-4 pb-5'>
                                <h5 className='fw-semibold'>Niet verwerkt</h5>
                                <div className=''>
                                    <div>
                                        <table className='w-100 border-0 mb-0'>
                                            <thead className='bottom-border-gray'>
                                                <tr className='ps-0'>
                                                    <th className='ps-0'>Producten</th>
                                                    <th className='text-center text-wrap'>Aantal</th>
                                                    <th className='text-center text-wrap'>Restitutie bedrag</th>
                                                    <th className='text-center text-wrap'>Voorraad toevoegen</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {soldProducts.map((product, index) => {
                                                    if (product.amount - product.items_processed - product.items_credited > 0) return (
                                                        <tr key={index} className='bottom-border-gray'>
                                                            <td className="text-start w-75 ps-0">
                                                                <div className='d-flex align-items-center linkColor'>
                                                                    <div className='pe-4'>
                                                                        <img
                                                                            src={
                                                                                product.image?.path
                                                                                    ? middleware.defaults.imagesBaseURL +
                                                                                        product.image?.path
                                                                                    : placeholder
                                                                            }
                                                                            className="rounded-circle"
                                                                            height={80}
                                                                            width={80}
                                                                            alt="placeholder..."
                                                                        />
                                                                    </div>
                                                                    {product.product_name}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='d-flex justify-content-center'>
                                                                    <CurrencyInput
                                                                        step="1"
                                                                        className='stockInput standardInput fw-semibold py-2 text-center'
                                                                        placeholder="-"
                                                                        allowDecimals={false}
                                                                        allowNegativeValue={false}
                                                                        min={0}
                                                                        onValueChange={(event) => changeUnProcessedProductCancelValue(event, product, "value")}
                                                                        value={cancelUnProcessedProducts[product.sold_product_id]?.value ?? ''}
                                                                    />
                                                                    <div className='stockInput3 standardInput py-2'>van {product.amount - product.items_processed - product.items_credited}</div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='d-flex justify-content-center'>
                                                                    <input
                                                                        disabled={(cancelUnProcessedProducts[product.sold_product_id]?.value ?? 0) == 0}
                                                                        value={cancelUnProcessedProducts[product.sold_product_id]?.restitution ?? ''}
                                                                        onChange={(event) => changeUnProcessedProductCancelValue(event, product, "restitution")}
                                                                        type='text'
                                                                        inputMode='decimal'  // Shows numeric keyboard on mobile
                                                                        pattern='[0-9]*[.,]?[0-9]*'  // Allows numbers with comma or dot
                                                                        placeholder='€ 0,00'
                                                                        className='standardInput fw-semibold squareInput packagesInput fit-content text-nowrap text-center py-2 px-2'
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='d-flex justify-content-center'>
                                                                    <RegularCheckBox
                                                                        label=""
                                                                        value={cancelUnProcessedProducts[product.sold_product_id]?.addToStock ?? false}
                                                                        setValue={(checked) => {
                                                                            const event = { target: { checked } };
                                                                            changeUnProcessedProductCancelValue(event, product, "addToStock");
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}

                        {soldProducts.find((e) => e.items_processed > 0) && (
                            <div className='whiteBox mb-4 me-2 p-4 pb-5'>
                                <h5 className='fw-semibold'>Verwerkt</h5>
                                <div className=''>
                                    <div>
                                        <table className='w-100 border-0 mb-0'>
                                            <thead className='bottom-border-gray'>
                                                <tr>
                                                    <th className='p-0'>Producten</th>
                                                    <th className='text-center text-wrap'>Aantal</th>
                                                    <th className='text-center text-wrap'>Restitutie bedrag</th>
                                                    <th className='text-center text-wrap'>Voorraad toevoegen</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {soldProducts.map((product, index) => {
                                                    if (product.items_processed) return (
                                                        <tr key={index} className='bottom-border-gray'>
                                                            <td className="text-start w-75 ps-0">
                                                                <div className='d-flex align-items-center linkColor'>
                                                                    <div className='pe-4'>
                                                                        <img
                                                                            src={
                                                                                product.image?.path
                                                                                    ? middleware.defaults.imagesBaseURL +
                                                                                        product.image?.path
                                                                                    : placeholder
                                                                            }
                                                                            className="rounded-circle"
                                                                            height={80}
                                                                            width={80}
                                                                            alt="placeholder..."
                                                                        />
                                                                    </div>
                                                                    {product.product_name}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='d-flex justify-content-center'>
                                                                    <CurrencyInput
                                                                        step="1"
                                                                        className='stockInput standardInput fw-semibold  py-2 text-center'
                                                                        placeholder="-"
                                                                        allowDecimals={false}
                                                                        allowNegativeValue={false}
                                                                        min={0}
                                                                        onValueChange={(event) => changeProcessedProductCancelValue(event, product, "value")}
                                                                        value={cancelProcessedProducts[product.sold_product_id]?.value ?? ''}
                                                                    />
                                                                    <div className='stockInput3 standardInput py-2'>van {product.items_processed}</div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='d-flex justify-content-center'>
                                                                    <input
                                                                        disabled={(cancelProcessedProducts[product.sold_product_id]?.value ?? 0) == 0}
                                                                        value={cancelProcessedProducts[product.sold_product_id]?.restitution ?? ''}
                                                                        onChange={(event) => changeProcessedProductCancelValue(event, product, "restitution")}
                                                                        type='text'  // Changed from 'number' to 'text'
                                                                        inputMode='decimal'  // Shows numeric keyboard on mobile
                                                                        pattern='[0-9]*[.,]?[0-9]*'  // Allows numbers with comma or dot
                                                                        placeholder='€ 0,00'
                                                                        className='standardInput fw-semibold squareInput packagesInput fit-content text-nowrap text-center py-2 px-2'
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='d-flex justify-content-center'>
                                                                    <RegularCheckBox
                                                                        label=""
                                                                        value={cancelProcessedProducts[product.sold_product_id]?.addToStock ?? false}
                                                                        setValue={(checked) => {
                                                                            const event = { target: { checked } };
                                                                            changeProcessedProductCancelValue(event, product, "addToStock");
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}

                        {order.shipment_method === 1 && !deliveryRestituted && (
                            <div className='whiteBox mb-4 me-2 p-4 h-100'>
                                <h5 className='fw-semibold'>Extras</h5>
                                <table className='w-100 border-0 mb-0'>
                                    <thead className='bottom-border-gray'>
                                        <tr>
                                            <th className='p-0'>Producten</th>
                                            <th className='text-center text-wrap'>Aantal</th>
                                            <th className='text-center text-wrap'>Restitutie bedrag</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr className='bottom-border-gray'>
                                            <td className="text-start w-75 ps-0">
                                                <div className='d-flex align-items-center linkColor'>
                                                    <div className='pe-4'>
                                                        <img src={deliveryTruckBlue} className="p-2 ps-0 pe-5" height={80} alt="placeholder..." />
                                                        <span>Verzendkosten</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='d-flex justify-content-center'>
                                                    <CurrencyInput
                                                        step="1"
                                                        className='stockInput standardInput fw-semibold  py-2 text-center'
                                                        placeholder="-"
                                                        allowDecimals={false}
                                                        allowNegativeValue={false}
                                                        min={0}
                                                        value={extra ?? ''}
                                                        onValueChange={(value) => {
                                                            value = value >= 1 ? 1 : value;
                                                            setExtra(value);
                                                        }}
                                                    />
                                                    <div className='stockInput3 standardInput py-2'>van 1</div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='d-flex justify-content-center'>
                                                    <input
                                                        disabled={true}
                                                        type='number'
                                                        placeholder='€ 0,00'
                                                        value={extracost ?? ''}
                                                        className='standardInput fw-semibold squareInput packagesInput fit-content text-nowrap text-center py-2 px-2'
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    <div className='d-flex flex-column col-xxl-4 col-7 h-100 gap-4'>
                        <div className='whiteBox p-4'>
                            <h5 className='fw-semibold pb-4'>Annuleringsreden</h5>
                            <div className='mb-3'>
                                <BorderedDropDown
                                    selectedValue={cancelReason}
                                    setSelectedValue={setCancelReason}
                                    placeholder='Selecteer een annuleringsreden'
                                    options={[
                                        { value: "Beschadigd of defect bij ontvangst", title: "Beschadigd of defect bij ontvangst" },
                                        { value: "Foutieve maat of pasvorm", title: "Foutieve maat of pasvorm" },
                                        { value: "Niet zoals beschreven", title: "Niet zoals beschreven" },
                                        { value: "Verlies van interesse of wijziging van voorkeur", title: "Verlies van interesse of wijziging van voorkeur" },
                                        { value: "Verkeerde kleur of stijl", title: "Verkeerde kleur of stijl" },
                                        { value: "other", title: 'Overige reden' },
                                    ]}
                                />
                            </div>                            
                            
                            {cancelReason === 'other' && (
                                <BorderedTextInput
                                    inputValue={otherCancelReason}
                                    setInputValue={setOtherCancelReason}
                                    placeholder={'Vul een overige reden in...'}
                                />
                            )}
                        </div>

                        <div className='whiteBox p-4'>
                            <h5 className='fw-semibold pb-3'>Samenvatting</h5>
                            <div className='d-flex justify-content-between '>
                                <h6>
                                    Producten restitutie
                                </h6>
                                <h6>
                                    {formatCurrency(productRestitution)}
                                </h6>
                            </div>
                            <div className='d-flex justify-content-between align-items-center pb-4 bottom-border-gray'>
                                <h6 className='m-0'>
                                    Restitutiekosten
                                </h6>
                                <div className='d-flex align-items-center justify-content-end'>
                                    -
                                    <BorderedSquareMoneyInput
                                        size='m'
                                        maxAmount={productRestitution}
                                        minAmount={0}
                                        inputValue={restitutionCost}
                                        setInputValue={setRestitutionCost}
                                    />
                                </div>
                            </div>
                            <div className='d-flex justify-content-between align-items-center pt-4 pb-4'>
                                <h6 className='m-0 fw-bold'>
                                    Totaal incl. BTW
                                </h6>
                                <h6 className='fw-bold'>
                                    {formatCurrency(productRestitution - (Number(restitutionCost.replace(',', '.'))))}
                                </h6>
                            </div>
                            {/* <div className='d-flex justify-content-start align-items-center pb-4'>
                                <label className="checkbox-container">
                                    <input
                                        type='checkbox'
                                        checked={selectAll}
                                        onChange={handleSelectAllChange}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                                <h6 className='m-0 pt-1'>Alle producten aan voorraad toevoegen</h6>
                            </div> */}
                            <button className='lightBlueStandardButton' onClick={() => cancelOrder()}>Crediteren</button>
                        </div>
                    </div>
                </div>
            </div>
        </PageTemplate>
    );
}

export default CancelOrder;